import { render } from "./AsBannersCatalog.vue?vue&type=template&id=e1353ea4&ts=true"
import script from "./AsBannersCatalog.vue?vue&type=script&lang=ts"
export * from "./AsBannersCatalog.vue?vue&type=script&lang=ts"

import "./AsBannersCatalog.vue?vue&type=style&index=0&id=e1353ea4&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__